import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Brush = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M13.707 2.293a.999.999 0 00-1.414 0l-5.84 5.84c-.015-.001-.029-.009-.044-.009a.997.997 0 00-.707.293L4.288 9.831a2.985 2.985 0 00-.878 2.122c0 .802.313 1.556.879 2.121l.707.707-2.122 2.122A2.92 2.92 0 002 19.012a2.968 2.968 0 001.063 2.308c.519.439 1.188.68 1.885.68.834 0 1.654-.341 2.25-.937l2.04-2.039.707.706c1.134 1.133 3.109 1.134 4.242.001l1.415-1.414a.997.997 0 00.293-.707c0-.026-.013-.05-.015-.076l5.827-5.827a.999.999 0 000-1.414l-8-8zm-.935 16.024a1.023 1.023 0 01-1.414-.001l-1.414-1.413a.999.999 0 00-1.414 0l-2.746 2.745a1.19 1.19 0 01-.836.352.91.91 0 01-.594-.208A.978.978 0 014 19.01a.959.959 0 01.287-.692l2.829-2.829a.999.999 0 000-1.414L5.701 12.66a.99.99 0 01-.292-.706c0-.268.104-.519.293-.708l.707-.707 7.071 7.072-.708.706zm1.889-2.392L8.075 9.339 13 4.414 19.586 11l-4.925 4.925z",
    key: "k0"
  }));
});
Brush.displayName = 'Brush';
export var BrushDimensions = {
  height: 24,
  width: 24
};